import script from "./shared.vue?vue&type=script&lang=ts"
export * from "./shared.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__